import { Country } from 'country-state-city'
import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import supportedCountries from '../../configs/supportedCountries'

const CountrySelect = ({ countryCode, handleChange, portal }) => {
  const [selectedCountry, setSelectedCountry] = useState({})
  const [countries, setCountries] = useState(supportedCountries(Country.getAllCountries().map(c => c.isoCode)))

  useEffect(() => {
    if (!portal.international_shipping) {
      setCountries([])
    } else if (portal.supported_countries.length) {
      setCountries(supportedCountries(portal.supported_countries))
    }
  }, [portal])

  useEffect(() => {
    const country = countries.find(country => country.country_code === countryCode)
    if (country) {
      setSelectedCountry(country)
    }
  }, [countryCode, countries])

  useEffect(() => {
    handleChange(selectedCountry)
  }, [selectedCountry])

  const customStyles = {
    singleValue: (provided, state) => {
      const overflow = 'none'
      return { ...provided, overflow }
    }
  }

  return (
    <Select
      defaultInputValue={selectedCountry.name}
      value={selectedCountry}
      onChange={setSelectedCountry}
      options={countries}
      getOptionLabel={option => option.name}
      getOptionValue={option => option.country_code}
      styles={customStyles}
    />
  )
}

const mapStateToProps = state => {
  return {
    portal: state.portal
  }
}

export default connect(mapStateToProps)(CountrySelect)
